import React from 'react';
import { Checkbox } from '../../ui/checkbox';
import { AlertCircle } from 'lucide-react';

const LotsUserTypeSection = ({
  formData,
  handleInputChange,
  errors,
  isDark
}) => {
  const lotsUserTypeOptions = [
    { label: 'Owners', value: 'owner' },
    { label: 'Residents/Tenants', value: 'residents-tenants' },
    { label: 'Agents', value: 'agent' },
  ];

  return (
    <>
      <div className={`border-none rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] transition-colors duration-200 ${
        isDark ? 'bg-[#000000]' : 'bg-white'
      } ${errors.lotsUserTypes ? 'border-[#FF0000]' : ''}`}>
        {/* Header */}
        <div className={`text-[16px] font-semibold transition-colors duration-200 ${
          isDark ? 'text-white' : 'text-[#072837]'
        }`}>
          Lots user type
        </div>

        {/* Checkbox options */}
        <div className="flex flex-col gap-[16px]">
          {lotsUserTypeOptions.map((option) => (
            <div key={option.value} className="flex items-center gap-[8px]">
              <Checkbox
                id={`lotsUserTypes-${option.value}`}
                checked={formData.lotsUserTypes?.includes(option.value) || false}
                onCheckedChange={(checked) => {
                  handleInputChange('lotsUserTypes', option.value);
                }}
                isDark={isDark}
              />
              <label 
                htmlFor={`lotsUserTypes-${option.value}`}
                className={`text-[16px] font-normal cursor-pointer transition-colors duration-200 ${
                  isDark ? 'text-white' : 'text-[#072837]'
                }`}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Error message */}
      {errors.lotsUserTypes && (
        <div className="w-full max-w-[822px] rounded-[16px] px-[8px] flex items-start gap-[8px] text-[14px] font-semibold text-[#FF0000]">
          <AlertCircle className="w-[16px] h-[16px]" />
          <span>You are required to select user type</span>
        </div>
      )}
    </>
  );
};

export default LotsUserTypeSection;

